import {
  cryptoUint32,
  randomInt,
  sampleIndices,
  type Uint32Source,
} from "@/lib/tool-kit/random-fun/rng";

/** The largest range the shared generator can draw from without losing precision. */
export const MAX_RANGE_SIZE = 2 ** 53;

/** How many values a range from `min` to `max` (both included) holds. */
export function rangeSize(min: number, max: number): number {
  return max - min + 1;
}

/** Whole numbers whose range (when `min <= max`) the shared generator can draw from exactly. */
export function isDrawableRange(min: number, max: number): boolean {
  return (
    Number.isSafeInteger(min) &&
    Number.isSafeInteger(max) &&
    rangeSize(min, max) <= MAX_RANGE_SIZE
  );
}

/**
 * `count` numbers from `min` to `max`, each uniformly likely.
 *
 * With `unique` the batch holds no repeats and is drawn without rejection loops
 * (Floyd's algorithm), so a near-full range such as 1000 of 1000 values stays instant.
 * The caller checks that the range is drawable and, for a unique batch, large enough.
 */
export function drawNumbers(
  min: number,
  max: number,
  count: number,
  unique: boolean,
  source: Uint32Source = cryptoUint32
): number[] {
  if (unique) {
    return sampleIndices(rangeSize(min, max), count, source).map(
      (offset) => min + offset
    );
  }
  const values: number[] = [];
  for (let i = 0; i < count; i += 1) {
    values.push(randomInt(min, max, source));
  }
  return values;
}
